var exports = {
  "Hx": "Flash__o-ckE2",
  "az": "Box__gM_WfF",
  "m4": "Octicon__2gPthZ",
};

module.exports = exports;
